import React, { useEffect, useState } from "react";
import {
  getServiceCenterListApi,
  getTodayBillReportByServiceCenter,
} from "../../services/ServiceApi";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { Link } from "react-router-dom";
import { MdAdd } from "react-icons/md";
import AddServiceCenterModal from "./AddServiceCenterModal";
import { BiSolidReport } from "react-icons/bi";
import { IconButton, Menu } from "@mui/material";
import {
  FaCheckCircle,
  FaAdjust,
  FaRupeeSign,
  FaTimesCircle,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
const ServiceCenter = () => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [addModal, setAddModal] = useState(false);
  const [reportLoading, setReportLoading] = useState(false);
  const [reportOption, setReportOption] = useState(null);
  const reportOptionOpen = Boolean(reportOption);
  const [toDayReport, setTodayReport] = useState({
    total_amount: 0,
    total_payment: 0,
    outstanding: 0,
    total_tips: 0,
    total_discounts: 0,
    final_amount: 0,
    paid_count: 0,
    unpaid_count: 0,
    partially_paid_count: 0,
  });
  const handleClick = (event, id) => {
    setReportOption(event.currentTarget);
    getTodayReport(id);
  };
  const handleClose = () => {
    setReportOption(null);
    setTodayReport({});
  };
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });

  const handleToggleAddModal = () => {
    setAddModal(!addModal);
  };
  const getTodayReport = (id) => {
    setReportLoading(true);
    getTodayBillReportByServiceCenter(id)
      .then((res) => {
        setTodayReport(res?.data?.results);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setReportLoading(false);
      });
  };
  const getData = () => {
    setLoading(true);
    getServiceCenterListApi(param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, [param]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleAfterServicecenterAdd = () => {
    handleToggleAddModal();
    getData();
  };
  const getValueByKey = (obj, key) => {
    return key
      .split(".")
      .reduce((acc, part) => (acc ? acc[part] : undefined), obj);
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <FaSort className="sort-icon neutral" />;
    }
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sort-icon active" />
    ) : (
      <FaSortDown className="sort-icon active" />
    );
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...data].sort((a, b) => {
      const valA = getValueByKey(a, key);
      const valB = getValueByKey(b, key);

      const numA = parseFloat(valA);
      const numB = parseFloat(valB);
      const dateA = Date.parse(valA);
      const dateB = Date.parse(valB);

      // Numeric sort if both are valid numbers
      if (!isNaN(numA) && !isNaN(numB)) {
        return direction === "asc" ? numA - numB : numB - numA;
      }

      // Date sort if both are valid dates
      if (!isNaN(dateA) && !isNaN(dateB)) {
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      }

      // Fallback to string sort (letters, "inf", etc.)
      return direction === "asc"
        ? String(valA).localeCompare(String(valB), undefined, {
            sensitivity: "base",
          })
        : String(valB).localeCompare(String(valA), undefined, {
            sensitivity: "base",
          });
    });

    setData(sorted);
  };
  return (
    <div>
      <div className="card">
        <div className="p-4 d-flex justify-content-between gap-2 flex-wrap">
          <div className="d-flex gap-1 flex-fill flex-md-grow-0">
            <div className="flex-fill">
              <DebounceSmallSearchInput
                handleSearchChange={handleSearchChange}
              />
            </div>
          </div>
          <button
            className="btn btn-primary px-2"
            onClick={handleToggleAddModal}
            style={{ padding: "0.45rem 0" }}
          >
            <MdAdd className="me-1" size="20" />
            Add Service Center
          </button>
        </div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <div className="text-center my-4 text-danger">{error}</div>
        ) : data && data?.length > 0 ? (
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th
                    onClick={() => handleSort("name")}
                    style={{ cursor: "pointer" }}
                  >
                    Name{renderSortIcon("name")}
                  </th>
                  <th
                    onClick={() => handleSort("total_cash")}
                    style={{ cursor: "pointer" }}
                  >
                    Total Cash{renderSortIcon("total_cash")}
                  </th>
                  <th
                    onClick={() => handleSort("total_baddebt")}
                    style={{ cursor: "pointer" }}
                  >
                    Total Baddebt{renderSortIcon("total_baddebt")}
                  </th>
                  <th
                    onClick={() => handleSort("total_unpaid_adjusted")}
                    style={{ cursor: "pointer" }}
                  >
                    Total Unpaid{renderSortIcon("total_unpaid_adjusted")}
                  </th>
                  <th
                    onClick={() => handleSort("total_petty_cash")}
                    style={{ cursor: "pointer" }}
                  >
                    Petty Cash{renderSortIcon("total_petty_cash")}
                  </th>
                  <th>Today Report</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={item.id}>
                    <td>
                      {" "}
                      <Link
                        className="fw-medium"
                        to={`/service-center/${item?.id}`}
                      >
                        {item?.name || "-"}
                      </Link>
                    </td>
                    <td>{item?.total_cash || "-"}</td>
                    <td>{item?.total_baddebt || "-"}</td>
                    <td>{item?.total_unpaid_adjusted || "-"}</td>
                    <td>{item?.total_petty_cash || "-"}</td>
                    <td>
                      <IconButton
                        size="small"
                        onClick={(e) => handleClick(e, item?.id)}
                        style={{ border: "1px solid #ddd" }}
                      >
                        <BiSolidReport className="text-dark" />
                      </IconButton>

                      <Menu
                        anchorEl={reportOption}
                        open={reportOptionOpen}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        PaperProps={{
                          elevation: 1,
                          sx: {
                            p: 1,
                            boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
                            borderRadius: "8px",
                            width: {
                              xs: "90vw",
                            },
                            minWidth: { sm: "250px" },
                            maxWidth: { sm: "280px" },
                          },
                        }}
                      >
                        <div>
                          <h6 className="fw-bold mb-3 text-primary">
                            Today’s Billing Summary
                          </h6>
                          <div className="d-flex flex-wrap gap-2 mb-3">
                            <span className="badge text-bg-success-soft rounded-pill d-flex align-items-center gap-1">
                              <FaCheckCircle /> Paid:
                              {toDayReport?.paid_count || "0"}
                            </span>
                            <span className="badge text-bg-danger-soft rounded-pill d-flex align-items-center gap-1">
                              <FaTimesCircle /> Unpaid:
                              {toDayReport?.unpaid_count || "0"}
                            </span>
                            <span className="badge text-bg-warning-soft rounded-pill text-dark d-flex align-items-center gap-1">
                              <FaAdjust /> Partial:
                              {toDayReport?.partially_paid_count || "0"}
                            </span>
                          </div>

                          <ul
                            className="list-unstyled mb-0"
                            style={{ fontSize: "0.8rem" }}
                          >
                            <li className="d-flex justify-content-between">
                              <span className="text-dark fw-medium">
                                Total Amount:
                              </span>
                              <span className="text-darker fw-medium">
                                <FaRupeeSign size="11" />
                                {toDayReport?.total_amount || "0"}
                              </span>
                            </li>
                            <li className="d-flex justify-content-between">
                              <span className="text-dark fw-medium">
                                Payment Received:
                              </span>
                              <span className="text-darker fw-medium">
                                <FaRupeeSign size="11" />
                                {toDayReport?.total_payment || "0"}
                              </span>
                            </li>
                            <li className="d-flex justify-content-between">
                              <span className="text-dark fw-medium">
                                Outstanding:
                              </span>
                              <span className="text-darker fw-medium">
                                <FaRupeeSign size="11" />
                                {toDayReport?.outstanding || "0"}
                              </span>
                            </li>
                            <li className="d-flex justify-content-between">
                              <span className="text-dark fw-medium">
                                Total Tips:
                              </span>
                              <span className="text-darker fw-medium">
                                <FaRupeeSign size="11" />
                                {toDayReport?.total_tips || "0"}
                              </span>
                            </li>
                            <li className="d-flex justify-content-between">
                              <span className="text-danger">
                                Total Discount:
                              </span>
                              <span className="text-danger">
                                <FaRupeeSign size="11" />
                                {toDayReport?.total_discounts || "0"}
                              </span>
                            </li>
                          </ul>

                          <div className="mt-3 border-top pt-2">
                            <div className="d-flex justify-content-between fw-medium text-darker">
                              <span>Final Amount:</span>
                              <span>
                                <FaRupeeSign size="14" />
                                {toDayReport?.final_amount || "0"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Menu>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center my-4">No data found</div>
        )}
        {!loading && data?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>

      <AddServiceCenterModal
        visible={addModal}
        onClose={handleToggleAddModal}
        onAfterSubmit={handleAfterServicecenterAdd}
      />
    </div>
  );
};

export default ServiceCenter;
